<template>
  <div
    v-if="hasValidQRCode"
    class="qrcode-wrapper"
    :class="combined ? null : ['qr-standalone', positionClass]"
  >
    <div class="bg-wrapper">
      <svg class="bg-image" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270.03 134.69" preserveAspectRatio="none">
        <defs>
          <linearGradient id="qr-gradient" x1="0" y1="67.34" x2="270.03" y2="67.34" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#f5e4b9"/>
            <stop offset=".05" stop-color="#f7e7bf"/>
            <stop offset=".2" stop-color="#fbeecb"/>
            <stop offset=".41" stop-color="#fef1d2"/>
            <stop offset="1" stop-color="#fff3d4"/>
          </linearGradient>
        </defs>
        <path fill="url(#qr-gradient)" d="M245.41,96.6h10.98c-1.95,9.7-4.88,19.19-8.77,28.4-1.39,3.3-2.9,6.53-4.51,9.7h-12.2c2.52-4.48,4.8-9.11,6.81-13.88,3.33-7.87,5.9-15.95,7.69-24.21ZM247.62,9.69c-1.39-3.3-2.9-6.53-4.52-9.69h-12.2c2.52,4.48,4.79,9.11,6.81,13.88,3.33,7.87,5.9,15.95,7.69,24.21h10.98c-1.95-9.7-4.88-19.19-8.77-28.4ZM227.82,18.07c-2.67-6.3-5.81-12.33-9.42-18.07h-12.94c4.95,6.91,9.12,14.35,12.46,22.26,2.19,5.17,3.98,10.45,5.39,15.83h11.08c-1.62-6.82-3.81-13.5-6.57-20.02ZM217.92,112.43c-3.34,7.9-7.51,15.34-12.46,22.26h12.94c3.61-5.74,6.75-11.77,9.42-18.07,2.76-6.52,4.95-13.2,6.57-20.02h-11.08c-1.4,5.38-3.2,10.66-5.39,15.83ZM267.34,38.09h-10.95c1.92,9.57,2.89,19.34,2.89,29.25s-.97,19.68-2.89,29.25h10.95c1.79-9.59,2.69-19.35,2.69-29.25s-.9-19.67-2.69-29.25ZM245.41,38.09h-11.02c2.26,9.53,3.4,19.3,3.4,29.25s-1.14,19.73-3.4,29.25h11.02c2.08-9.55,3.12-19.32,3.12-29.25s-1.05-19.7-3.12-29.25ZM205.54,67.34c0-10.04-1.55-19.85-4.63-29.25h11.25c-1.14-3.94-2.52-7.83-4.14-11.65-4.07-9.62-9.48-18.48-16.15-26.44h-113.71c-6.67,7.96-12.08,16.83-16.15,26.44-1.61,3.82-3,7.7-4.14,11.65h11.25c-3.07,9.4-4.63,19.21-4.63,29.25s1.55,19.85,4.63,29.25h-11.25c1.14,3.94,2.52,7.83,4.14,11.65,4.07,9.62,9.48,18.48,16.15,26.44h14.62c-.22-.22-.44-.44-.66-.66l.67.1v.2h84.47v-.2l.67-.1c-.22.22-.44.44-.66.66h14.62c6.67-7.96,12.08-16.83,16.15-26.44,1.61-3.82,3-7.7,4.14-11.65h-11.25c3.07-9.4,4.63-19.21,4.63-29.25ZM223.31,38.09h-11.15c2.74,9.46,4.13,19.25,4.13,29.25s-1.39,19.8-4.13,29.25h11.15c2.48-9.49,3.73-19.28,3.73-29.25s-1.25-19.76-3.73-29.25ZM22.41,124.99c1.39,3.3,2.9,6.53,4.51,9.7h12.2c-2.52-4.48-4.8-9.11-6.81-13.88-3.33-7.87-5.9-15.95-7.69-24.21h-10.98c1.95,9.7,4.88,19.19,8.77,28.4ZM32.31,13.88c2.02-4.77,4.29-9.4,6.81-13.88h-12.2c-1.62,3.16-3.12,6.4-4.52,9.69-3.89,9.21-6.82,18.7-8.77,28.4h10.98c1.79-8.26,4.36-16.35,7.69-24.21ZM52.11,22.26c3.34-7.9,7.51-15.34,12.46-22.26h-12.94c-3.61,5.74-6.75,11.77-9.42,18.07-2.76,6.52-4.95,13.21-6.57,20.02h11.08c1.4-5.38,3.2-10.66,5.39-15.83ZM42.21,116.62c2.67,6.3,5.81,12.33,9.42,18.07h12.94c-4.95-6.91-9.12-14.35-12.46-22.26-2.19-5.17-3.98-10.46-5.39-15.83h-11.08c1.62,6.82,3.81,13.5,6.57,20.02ZM13.64,38.09H2.69c-1.79,9.59-2.69,19.35-2.69,29.25s.9,19.67,2.69,29.25h10.95c-1.92-9.57-2.89-19.34-2.89-29.25s.97-19.68,2.89-29.25ZM35.64,38.09h-11.02c-2.08,9.55-3.12,19.32-3.12,29.25s1.05,19.71,3.12,29.25h11.02c-2.26-9.52-3.4-19.3-3.4-29.25s1.14-19.73,3.4-29.25ZM57.87,38.09h-11.15c-2.48,9.49-3.73,19.28-3.73,29.25s1.25,19.76,3.73,29.25h11.15c-2.74-9.46-4.13-19.25-4.13-29.25s1.39-19.79,4.13-29.25Z"/>
      </svg>
      <div class="qrcode-content">
        <img
          :src="item.enquete_qr_code.url"
          :alt="qrCodeAltText"
          class="qrcode-image"
          @error="onQRCodeError"
        />
        <span class="participe-text">PARTICIPE!</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardTarjaEnqueteCopaTVFechadaQRCODE',
  props: {
    item: {
      type: Object,
      default: () => null
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    posicaoEnquete: {
      type: String,
      default: 'esquerda'
    },
    // True when embedded in the combined wrapper, which handles positioning itself.
    // When false (standalone qrcode mode), this component positions itself.
    combined: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {}
  },
  computed: {
    hasValidQRCode() {
      return this.item?.enquete_qr_code?.url && this.item.enquete_qr_code.url.trim() !== '';
    },
    qrCodeAltText() {
      return `QR Code - ${this.item?.dsc_titulo_enquete || 'Participe da Enquete'}`;
    },
    positionClass() {
      const map = { esquerda: 'pos-left', centro: 'pos-center', direita: 'pos-right' };
      return map[this.posicaoEnquete] || 'pos-left';
    }
  },
  methods: {
    onQRCodeError(event) {
      console.error('Error loading QR Code image:', event);
      this.$emit('qrcode-error', {
        url: this.item?.enquete_qr_code?.url,
        enqueteId: this.item?.id
      });
    }
  }
}
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Ferryman";
  font-weight: 900;
  font-style: italic;
  src: url("@/assets/CopaTVFechada/Ferryman/Ferryman Black Italic.otf") format("opentype");
}

.qrcode-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  padding: 0;
  margin: 0;
  z-index: 100;

  /* Standalone qrcode mode: honor the enquete position flag (grid item in tarjaRow)
     and keep a safe area off the edges. Ignored when combined, where the wrapper
     positions the unit instead. */
  &.qr-standalone {
    margin-bottom: 54px;
  }

  &.pos-left {
    justify-self: flex-start;
    margin-left: 35px;
  }

  &.pos-center {
    justify-self: center;
    margin-left: auto;
    margin-right: auto;
  }

  &.pos-right {
    justify-self: flex-end;
    margin-right: 35px;
  }
}

.bg-wrapper {
  position: relative;
  width: 270px;
  height: 135px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1; /* create stacking context */
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.qrcode-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0;
}

.qrcode-image {
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin-bottom: 3px;
}

.participe-text {
  font-family: 'Ferryman', serif;
  font-size: 18px;
  color: #075cd3;
  text-transform: uppercase;
}
</style>
